module.exports = __webpack_public_path__ + "img/rugby-ball.8c48694a.svg";